<template>
	<div>
		<div class="is-fetching">
			<div>
				<Shimmer :width="'40%'"/>
			</div>
			<div>
				<Shimmer :width="'40%'"/>
			</div>
			<div>
				<Shimmer :width="'40%'"/>
			</div>
			<div>
				<Shimmer :width="'40%'"/>
			</div>
			<div class="chat-is-fetching mt-3">
				<Shimmer :width="'100%'" :height="'500px'"/>
			</div>
			<div class="input-is-fetching mt-3">
				<Shimmer :width="'40%'" :height="'30px'"/>
			</div>
		</div>
	</div>
</template>

<script>
import Shimmer from '@/components/Shimmer.vue';

export default {
	name: 'TicketLoading',
	components: {
		Shimmer,
	},
	props: {
		isFetching: {
			type: Boolean,
			default: false,
		},
	},
};
</script>
